import { useSelector } from 'react-redux';

import useOrgConfig from 'src/hooks/discover/useOrgConfig';
import { selectIsUserSuperAdmin } from 'src/reducers/userReducer/userReducer';

// `conversation_drawer_v2` turns the redesigned drawer on for every dashboard
// user in the org; `conversation_drawer_beta` remains the internal switch that
// shows it to super admins only. Read from the org config, not
// `useIsFeatureFlagEnabled` — that hook serves the Solve flags, and these are
// dashboard flags, which only arrive in the org-config payload.
export const useIsAuditDrawerEnabled = () => {
  const { feature_flags: dashboardFeatureFlags = [] } = useOrgConfig();
  const isSuperAdmin = useSelector(selectIsUserSuperAdmin);

  return (
    dashboardFeatureFlags.includes('conversation_drawer_v2') ||
    (dashboardFeatureFlags.includes('conversation_drawer_beta') && isSuperAdmin)
  );
};
